export const ENVIRONMENTS = {
  LOCAL: "local",
  DEV: "dev",
  TEST: "test",
  PROD: "prod",
};

const normalizeEnv = (value) => {
  if (!value) {
    return null;
  }

  const normalizedValue = String(value).toLowerCase();
  return Object.values(ENVIRONMENTS).includes(normalizedValue)
    ? normalizedValue
    : null;
};

const resolveEnvFromHost = (host) => {
  if (!host) {
    return ENVIRONMENTS.DEV;
  }

  if (host.includes("localhost")) {
    return ENVIRONMENTS.LOCAL;
  }

  if (
    host === "gmenergy.gm.com" ||
    host.includes("prod") ||
    host.includes("-p2-")
  ) {
    return ENVIRONMENTS.PROD;
  }

  if (host.includes(".stage.") || host.includes("stage") || host.includes("-t2-")) {
    return ENVIRONMENTS.TEST;
  }

  if (host.includes("cdn-dev.gm.com") || host.includes("dev") || host.includes("-d2-")) {
    return ENVIRONMENTS.DEV;
  }

  return ENVIRONMENTS.DEV;
};

export const getCurrentEnv = () => {
  const appEnv = normalizeEnv(window.__APP_CONFIG__?.APP_ENV);
  if (appEnv) {
    return appEnv;
  }

  return resolveEnvFromHost(window.location.host);
};

export const getValueByEnv = (envMap) => {
  const env = getCurrentEnv();
  if (envMap[env] !== undefined) {
    return envMap[env];
  }

  if (envMap[ENVIRONMENTS.DEV] !== undefined) {
    return envMap[ENVIRONMENTS.DEV];
  }

  return undefined;
};